import { render, staticRenderFns } from "./VehicleGroupsPage.vue?vue&type=template&id=54b38058&scoped=true&"
import script from "./VehicleGroupsPage.vue?vue&type=script&lang=js&"
export * from "./VehicleGroupsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b38058",
  null
  
)

export default component.exports